module.exports = "./app-dist/templates/builder.directive.ba49676ae239cce1a76a76da6773bbbb.html";